<script setup>
  defineProps({
    show: { type: Boolean, default: false },
    countdownSeconds: { type: Number, default: 60 },
    isStopping: { type: Boolean, default: false }
  })

  const emit = defineEmits(['cancel', 'stop-now'])
</script>

<template>
  <Teleport to="body">
    <div v-if="show" class="idle-shutdown-overlay" role="dialog" aria-modal="true" aria-labelledby="idle-shutdown-title">
      <div class="idle-shutdown-modal bg-white rounded shadow-lg p-4" style="max-width: 450px; width: 90%;">
        <div class="text-center">
          <i class="bi bi-clock-history text-warning" style="font-size: 2.5rem;"></i>
          <h5 id="idle-shutdown-title" class="mt-3 mb-2"><strong>Inactivity Detected</strong></h5>
          <p class="text-14 text-muted mb-3">
            No activity detected for 1 hour. Instances will be stopped to save costs.
          </p>

          <div class="alert alert-warning py-2 mb-3">
            <span v-if="!isStopping" class="text-14">
              Shutting down in <strong>{{ countdownSeconds }}</strong> second{{ countdownSeconds !== 1 ? 's' : '' }}
            </span>
            <span v-else class="text-14">
              Stopping instances... This may take up to 4 minutes. Shutdown in progress cannot be cancelled.
            </span>
          </div>

          <div class="d-flex gap-2 justify-content-center">
            <button
              v-if="!isStopping"
              class="btn btn-primary"
              :disabled="isStopping"
              @click="emit('cancel')">
              Cancel Shut Down
            </button>
            <button
              class="btn btn-outline-danger"
              :disabled="isStopping"
              @click="emit('stop-now')">
              <span v-if="isStopping" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ isStopping ? 'Stopping...' : 'Stop Now' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
  .idle-shutdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
  }
</style>
